// Handles submission of the cart form
document.addEventListener('DOMContentLoaded', function () {
  // Only runs on moia-card-product element
  if (!customElements.get('moia-card-product')) {
    customElements.define(
      'moia-card-product',
      class MoiaCardProduct extends HTMLElement {
        constructor() {
          super();
          console.log('this rendered!');
          this.handleClick = this.handleClick.bind(this);
          this.addEventListener('click', this.handleClick);
        }

        handleClick(event) {
          const addToCartButton = event.target.closest('.moia-card-product-add-to-cart-button');

          if (addToCartButton && addToCartButton.dataset.id) {
            addOrUpdateCartItem(addToCartButton.dataset.id, 1, 'moia-card-product');
          }
        }

        disconnectedCallback() {
          // Clean up event listener when component is removed
          this.removeEventListener('click', this.handleClick);
        }
      }
    );
  }
});
